(function () {
  'use strict';

  var IS_MOBILE = window.innerWidth <= 768;

  /* ════════════════════════════════════════
     POSITIONEN BERECHNEN
  ════════════════════════════════════════ */
  function getHerbPositions(n) {
    var stage = document.getElementById('vbgIngaStage2');
    if (!stage) return [];
    var rect  = stage.getBoundingClientRect();
    var vw    = rect.width;
    var vh    = rect.height;
    var cx    = vw / 2;
    var cy    = vh * 0.55;
    var positions = [];

    /* Mobile nutzt Cover-Flow Carousel, keine absolute Positionierung */
    if (!IS_MOBILE) {
      var hx2 = Math.min(vw * 0.36, 340);
      var vy2 = Math.min(vh * 0.27, 175);
      var defaultPos = [
        { x: cx - hx2,        y: cy - vy2 * 1.05 },
        { x: cx + hx2,        y: cy - vy2 * 1.05 },
        { x: cx - hx2 * 1.18, y: cy },
        { x: cx + hx2 * 1.18, y: cy },
        { x: cx - hx2,        y: cy + vy2 * 1.05 },
        { x: cx + hx2,        y: cy + vy2 * 1.05 }
      ];
      for (var j = 0; j < n; j++) {
        if (defaultPos[j]) {
          positions.push(defaultPos[j]);
        } else {
          var angle = (j / n) * Math.PI * 2 - Math.PI / 2;
          positions.push({
            x: cx + hx2 * Math.cos(angle),
            y: cy + vy2 * Math.sin(angle)
          });
        }
      }
    }
    return positions;
  }

  /* ════════════════════════════════════════
     SVG LINIEN (nur Desktop)
  ════════════════════════════════════════ */
  var linesSvg = document.getElementById('vbgIngaLines');
  var lineEls  = [];

  function buildLines(n) {
    lineEls.forEach(function(l) { l.remove(); });
    lineEls = [];
    if (!linesSvg || IS_MOBILE) return;

    var stage = document.getElementById('vbgIngaStage2');
    if (!stage) return;
    var rect  = stage.getBoundingClientRect();
    var vw    = rect.width;
    var vh    = rect.height;
    var bx    = vw / 2;
    var by    = vh * 0.62;

    var positions = getHerbPositions(n);
    var cardW     = window.innerWidth <= 900 ? 150 : 200;
    var cardH     = 165;

    positions.forEach(function(pos) {
      var dx    = bx - pos.x;
      var dy    = by - pos.y;
      var len   = Math.sqrt(dx * dx + dy * dy);
      var edgeX = pos.x + (dx / len) * (cardW / 2.2);
      var edgeY = pos.y + (dy / len) * (cardH / 2.2);
      var mx    = (edgeX + bx) / 2 + (dy / len) * 20;
      var my    = (edgeY + by) / 2 - (dx / len) * 20;

      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M' + edgeX + ',' + edgeY + ' Q' + mx + ',' + my + ' ' + bx + ',' + by);
      path.setAttribute('stroke', 'rgba(168,197,176,0.25)');
      path.setAttribute('stroke-width', '1');
      path.setAttribute('fill', 'none');
      path.style.opacity = '0';

      var pathLen = path.getTotalLength ? path.getTotalLength() : 200;
      path.setAttribute('stroke-dasharray', pathLen + ' ' + pathLen);
      path.style.strokeDashoffset = String(pathLen);

      linesSvg.appendChild(path);
      lineEls.push(path);
    });
  }

  /* ════════════════════════════════════════
     HYBRID LIST SPALTEN NEU ORDNEN
  ════════════════════════════════════════ */
  function reorderHybridList() {
    var list = document.getElementById('vbgIngaHybridList');
    if (!list) return;
    var isDesktop = window.innerWidth > 768;
    var normal    = Array.prototype.slice.call(list.querySelectorAll('.vbg-inga-hybrid-item:not(.is-featured):not(.vbg-inga-hybrid-ph)'));

    list.querySelectorAll('.vbg-inga-hybrid-ph').forEach(function(el) { el.remove(); });
    normal.forEach(function(el) { el.remove(); });

    if (isDesktop) {
      var total    = normal.length;
      var cols     = 3;
      var baseRows = Math.floor(total / cols);
      var extra    = total % cols;
      var colSizes = Array.from ? Array.from({ length: cols }, function(_, i) {
        return i < extra ? baseRows + 1 : baseRows;
      }) : [baseRows + (0 < extra ? 1 : 0), baseRows + (1 < extra ? 1 : 0), baseRows];
      var colStarts = [0];
      for (var c = 1; c < cols; c++) {
        colStarts[c] = colStarts[c - 1] + colSizes[c - 1];
      }
      var maxRows   = colSizes[0];
      var reordered = [];
      for (var row = 0; row < maxRows; row++) {
        for (var col = 0; col < cols; col++) {
          var idx = colStarts[col] + row;
          if (idx < colStarts[col] + colSizes[col]) {
            reordered.push(normal[idx]);
          } else {
            var ph = document.createElement('div');
            ph.className = 'vbg-inga-hybrid-item vbg-inga-hybrid-ph';
            ph.setAttribute('aria-hidden', 'true');
            ph.style.visibility = 'hidden';
            reordered.push(ph);
          }
        }
      }
      reordered.forEach(function(el) { list.appendChild(el); });
    } else {
      normal.forEach(function(el) { list.appendChild(el); });
    }
  }

  /* ════════════════════════════════════════
     ANIMATION STARTEN
  ════════════════════════════════════════ */
  function runAnimation() {
    var n      = window.vbgIngaHerbCount || 0;
    var stage  = document.getElementById('vbgIngaStage2');
    if (!stage || !window.gsap) return;

    gsap.set('#vbgIngaHeader2',        { opacity: 0, y: -24 });
    gsap.set('#vbgIngaBottle2',        { opacity: 0, scale: 1.2 });
    gsap.set('.vbg-inga-bottle2-halo', { opacity: 0, scale: 0.5 });
    gsap.set('#vbgIngaFooter2',        { opacity: 0, y: 20 });

    var tl = gsap.timeline();
    tl.to('#vbgIngaBottle2',        { opacity: 1, scale: 1, duration: 1.0, ease: 'back.out(1.3)' }, 0.2);
    tl.to('.vbg-inga-bottle2-halo', { opacity: 1, scale: 1, duration: 0.8, ease: 'power2.out' }, 0.4);
    tl.to('#vbgIngaHeader2',        { opacity: 1, y: 0,     duration: 0.7, ease: 'power2.out' }, 0.7);

    if (IS_MOBILE) {
      /* ── Mobile: 3D Entrance aus verschiedenen Richtungen ── */
      var mobileCards = document.querySelectorAll('.vbg-inga-card2');
      var vw = window.innerWidth;
      gsap.set('#vbgIngaCarousel', { opacity: 1 });
      gsap.set('#vbgIngaDots', { opacity: 0 });

      /* Jede Karte startet von einer anderen Richtung */
      var entrances = [
        { x: -vw,       y: -60,  rotateY: 90,  rotateX: 20  },  // links oben
        { x: vw,        y: -40,  rotateY: -90, rotateX: 15  },  // rechts oben
        { x: -vw * 0.7, y: 30,   rotateY: 70,  rotateX: -10 },  // links mitte
        { x: vw * 0.7,  y: 20,   rotateY: -70, rotateX: -15 },  // rechts mitte
        { x: -vw * 0.5, y: 100,  rotateY: 50,  rotateX: -20 },  // links unten
        { x: vw * 0.5,  y: 80,   rotateY: -50, rotateX: -25 }   // rechts unten
      ];

      mobileCards.forEach(function(card, i) {
        var e = entrances[i % entrances.length];
        gsap.set(card, {
          opacity: 0, x: e.x, y: e.y,
          rotateY: e.rotateY, rotateX: e.rotateX,
          scale: 0.3, z: -200
        });
      });

      /* Karten fliegen nacheinander ein und landen im Cover-Flow */
      mobileCards.forEach(function(card, i) {
        tl.to(card, {
          opacity: 1, x: 0, y: 0,
          rotateY: 0, rotateX: 0,
          scale: 1, z: 0,
          duration: 0.8, ease: 'power3.out'
        }, 0.9 + i * 0.15);
      });

      /* Cover-Flow starten nachdem alle Karten da sind */
      var entranceEnd = 0.9 + mobileCards.length * 0.15 + 0.3;
      tl.add(function() { initCarousel(); }, entranceEnd);
      tl.to('#vbgIngaDots', { opacity: 1, duration: 0.4 }, entranceEnd - 0.1);
    } else {
      /* ── Desktop: absolutes Positioning wie bisher ── */
      var positions = getHerbPositions(n);
      var rect      = stage.getBoundingClientRect();
      var vw        = rect.width;
      var vh        = rect.height;

      buildLines(n);

      for (var i = 1; i <= n; i++) {
        gsap.set('#vbgHerb' + i, {
          left: '50%', top: '50%',
          x: 0, y: 0,
          xPercent: -50, yPercent: -50,
          scale: 0.2, opacity: 0
        });
      }
      lineEls.forEach(function(l) { l.style.opacity = '0'; });

      for (var j = 0; j < n; j++) {
        var pos = positions[j];
        tl.to('#vbgHerb' + (j + 1), {
          x: pos.x - vw / 2, y: pos.y - vh / 2,
          xPercent: -50, yPercent: -50,
          scale: 1, opacity: 1,
          duration: 0.85, ease: 'back.out(1.15)'
        }, 1.1 + j * 0.10);
      }

      lineEls.forEach(function(line, i) {
        tl.to(line, { opacity: 1, strokeDashoffset: 0, duration: 0.6, ease: 'power2.out' }, 1.6 + i * 0.08);
      });

      /* Desktop-only: Linien-Daueranimation */
      lineEls.forEach(function(line, i) {
        gsap.to(line, { strokeDashoffset: '-=200', duration: 8, ease: 'none', repeat: -1, delay: 2.5 + i * 0.1 });
      });
    }

    tl.to('#vbgIngaFooter2', { opacity: 1, y: 0, duration: 0.7, ease: 'back.out(1.3)' }, 2.2);

    /* Bottle float animation (beide) */
    gsap.to('#vbgIngaBottle2',        { y: '-=8', duration: 3.2, ease: 'sine.inOut', repeat: -1, yoyo: true, delay: 1.8 });
    gsap.to('.vbg-inga-bottle2-halo', { scale: 1.15, opacity: 0.7, duration: 2.5, ease: 'sine.inOut', repeat: -1, yoyo: true, delay: 2 });
  }

  /* ════════════════════════════════════════
     INTERAKTIONEN
  ════════════════════════════════════════ */
  function initInteractions() {
    var stage         = document.getElementById('vbgIngaStage2');
    var dimmer        = document.getElementById('vbgIngaDimmer');
    var bottleWrap    = document.getElementById('vbgIngaBottle2');
    var bottleInner   = document.getElementById('vbgIngaBottleInner');
    var ingOverlay    = document.getElementById('vbgIngaIngOverlay');
    var ingClose      = document.getElementById('vbgIngaIngClose');
    var sheet         = document.querySelector('.vbg-inga-sheet');
    var sheetBackdrop = document.querySelector('.vbg-inga-sheet-backdrop');
    var sheetClose    = document.querySelector('.vbg-inga-sheet-close');
    var n             = window.vbgIngaHerbCount || 0;

    if (!stage || !dimmer || !bottleWrap) return;

    var activeCard = null;

    function closeCardAnim(card) {
      card.classList.remove('is-focused');
      if (IS_MOBILE) {
        gsap.to(card, {
          x: parseFloat(card.dataset.origX || 0),
          y: parseFloat(card.dataset.origY || 0),
          scale: 1, duration: 0.4, ease: 'back.out(1.2)',
          onComplete: function() { gsap.set(card, { zIndex: card.dataset.origZ || 25 }); }
        });
      } else {
        gsap.to(card, {
          x: parseFloat(card.dataset.origX || 0),
          y: parseFloat(card.dataset.origY || 0),
          scale: 1, duration: 0.4, ease: 'back.out(1.2)',
          onComplete: function() { gsap.set(card, { zIndex: card.dataset.origZ || 25 }); }
        });
      }
    }

    function closeActiveCard() {
      if (!activeCard) return;
      closeCardAnim(activeCard);
      activeCard = null;
      stage.classList.remove('has-focus');
      dimmer.classList.remove('is-active');
    }

    /* ── Sheet öffnen / schließen ── */
    function openSheet() {
      if (sheet)         sheet.classList.add('open');
      if (sheetBackdrop) sheetBackdrop.classList.add('open');
    }

    function closeSheet() {
      if (sheet)         sheet.classList.remove('open');
      if (sheetBackdrop) sheetBackdrop.classList.remove('open');
      if (bottleInner)   bottleInner.classList.remove('is-flipped');
      gsap.to('.vbg-inga-card2',    { opacity: 1, scale: 1, duration: 0.6, stagger: 0.05, delay: 0.3 });
    }

    if (sheetClose)    sheetClose.addEventListener('click', closeSheet);
    if (sheetBackdrop) sheetBackdrop.addEventListener('click', closeSheet);

    /* ── Karten-Klick ── */
    for (var i = 1; i <= n; i++) {
      (function(idx) {
        var card = document.getElementById('vbgHerb' + idx);
        if (!card) return;
        card.addEventListener('click', function(e) {
          e.stopPropagation();
          /* Mobile: Karten im Carousel, kein Focus nötig */
          if (IS_MOBILE) return;

          if (activeCard === card) { closeActiveCard(); return; }
          if (activeCard) {
            closeCardAnim(activeCard);
          } else {
            stage.classList.add('has-focus');
            dimmer.classList.add('is-active');
          }
          activeCard = card;
          card.classList.add('is-focused');

          if (!card.dataset.origX) {
            card.dataset.origX = gsap.getProperty(card, 'x');
            card.dataset.origY = gsap.getProperty(card, 'y');
            card.dataset.origZ = gsap.getProperty(card, 'zIndex') || 25;
          }
          gsap.set(card, { zIndex: 60 });
          gsap.to(card, { x: 0, y: 0, scale: 1.5, duration: 0.4, ease: 'back.out(1.2)' });
        });
      })(i);
    }

    /* ── Dimmer schließt Karte ── */
    dimmer.addEventListener('click', closeActiveCard);

    /* ── Flasche klicken → Sheet (Mobile) oder Overlay (Desktop) ── */
    bottleWrap.addEventListener('click', function() {
      if (activeCard) closeActiveCard();
      if (bottleInner) bottleInner.classList.add('is-flipped');

      // Live prüfen statt gecachtem IS_MOBILE – Safari liefert manchmal falschen Wert beim Init
      var isMobileNow = window.innerWidth <= 768;

      if (isMobileNow) {
        gsap.to('.vbg-inga-card2', { opacity: 0, scale: 0.8, duration: 0.4, stagger: 0.05 });
        setTimeout(openSheet, 400);
      } else {
        gsap.to('.vbg-inga-card2',    { opacity: 0, scale: 0.8, duration: 0.4, stagger: 0.05 });
        gsap.to('#vbgIngaLines path', { opacity: 0, duration: 0.3 });
        setTimeout(function() {
          if (ingOverlay) ingOverlay.classList.add('is-active');
        }, 400);
      }
    });

    /* ── Overlay schließen (Desktop) ── */
    if (ingClose) {
      ingClose.addEventListener('click', function() {
        if (ingOverlay) ingOverlay.classList.remove('is-active');
        if (bottleInner) bottleInner.classList.remove('is-flipped');
        gsap.to('.vbg-inga-card2',    { opacity: 1, scale: 1, duration: 0.6, stagger: 0.05, delay: 0.3 });
        gsap.to('#vbgIngaLines path', { opacity: 1, duration: 0.5, delay: 0.5 });
      });
    }

    /* ── Escape ── */
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      closeActiveCard();
      if (ingOverlay && ingOverlay.classList.contains('is-active')) {
        if (ingClose) ingClose.click();
      }
      if (sheet && sheet.classList.contains('open')) closeSheet();
    });
  }

  /* ════════════════════════════════════════
     3D COVER-FLOW CAROUSEL (nur Mobile)
  ════════════════════════════════════════ */
  function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }

  /* Cleanup-Referenzen um Memory Leaks bei Re-Init zu vermeiden */
  var _cfCleanup = null;

  function initCarousel() {
    /* Vorherige Instanz aufräumen (Timer, Listener) */
    if (_cfCleanup) { _cfCleanup(); _cfCleanup = null; }

    if (!IS_MOBILE || !window.gsap) return;
    var carousel = document.getElementById('vbgIngaCarousel');
    var cards    = carousel ? carousel.querySelectorAll('.vbg-inga-card2') : [];
    var dots     = document.querySelectorAll('.vbg-inga-dot');
    var n        = cards.length;
    if (n === 0) return;

    var currentIdx = 0;
    var spacing    = Math.min(window.innerWidth * 0.55, 200);
    var startX     = 0;
    var startIdx   = 0;
    var dragging   = false;
    var proxy      = { val: 0 };

    function render(idx) {
      var roundIdx = Math.round(idx);
      cards.forEach(function(card, i) {
        var diff    = i - idx;
        var absDiff = Math.abs(diff);

        var tx = diff * spacing;
        var ry = clamp(diff * -38, -50, 50);
        var tz = -absDiff * 60;
        var sc = Math.max(0.72, 1 - absDiff * 0.14);
        var op = Math.max(0.35, 1 - absDiff * 0.3);

        card.style.zIndex = String(Math.round(50 - absDiff * 10));
        gsap.set(card, {
          x: tx, rotateY: ry, z: tz,
          scale: sc, opacity: op,
          xPercent: -50, yPercent: 0
        });

        card.classList.toggle('is-cf-active', i === roundIdx);
      });

      dots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === roundIdx);
      });
    }

    /* ── Touch-Handlers (benannte Funktionen für Cleanup) ── */
    var startY    = 0;
    var direction = null;

    function onTouchStart(e) {
      dragging  = true;
      direction = null;
      startX    = e.touches[0].clientX;
      startY    = e.touches[0].clientY;
      startIdx  = currentIdx;
      gsap.killTweensOf(proxy);
    }

    function onTouchMove(e) {
      if (!dragging) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;

      if (!direction) {
        if (Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
        direction = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
      }

      if (direction === 'v') { dragging = false; return; }

      e.preventDefault();
      var newIdx = startIdx - dx / spacing;
      currentIdx = clamp(newIdx, -0.3, n - 1 + 0.3);
      render(currentIdx);
    }

    function onTouchEnd() {
      if (!dragging) return;
      dragging  = false;
      direction = null;
      var target = clamp(Math.round(currentIdx), 0, n - 1);
      proxy.val  = currentIdx;
      gsap.to(proxy, {
        val: target, duration: 0.45, ease: 'back.out(1.4)',
        onUpdate: function() { render(proxy.val); },
        onComplete: function() { currentIdx = target; }
      });
    }

    carousel.addEventListener('touchstart', onTouchStart, { passive: true });
    carousel.addEventListener('touchmove',  onTouchMove,  { passive: false });
    carousel.addEventListener('touchend',   onTouchEnd);

    /* ── Dot-Klick (Event-Delegation statt pro-Dot-Listener) ── */
    var dotsWrap = document.getElementById('vbgIngaDots');
    function onDotClick(e) {
      var dot = e.target.closest('.vbg-inga-dot');
      if (!dot) return;
      var target = parseInt(dot.dataset.index, 10);
      proxy.val  = currentIdx;
      gsap.to(proxy, {
        val: target, duration: 0.5, ease: 'power2.out',
        onUpdate: function() { render(proxy.val); },
        onComplete: function() { currentIdx = target; }
      });
    }
    if (dotsWrap) dotsWrap.addEventListener('click', onDotClick);

    /* ── Auto-Rotation ── */
    var autoTimer = setInterval(function() {
      if (dragging) return;
      var next  = (Math.round(currentIdx) + 1) % n;
      proxy.val = currentIdx;
      gsap.to(proxy, {
        val: next, duration: 0.7, ease: 'power2.inOut',
        onUpdate: function() { render(proxy.val); },
        onComplete: function() { currentIdx = next; }
      });
    }, 4000);

    var autoStopped = false;
    function stopAuto() {
      if (autoStopped) return;
      autoStopped = true;
      clearInterval(autoTimer);
    }
    carousel.addEventListener('touchstart', stopAuto, { once: true, passive: true });

    /* Initial render */
    render(0);

    /* ── Cleanup-Funktion registrieren ── */
    _cfCleanup = function() {
      clearInterval(autoTimer);
      carousel.removeEventListener('touchstart', onTouchStart);
      carousel.removeEventListener('touchmove',  onTouchMove);
      carousel.removeEventListener('touchend',   onTouchEnd);
      carousel.removeEventListener('touchstart', stopAuto);
      if (dotsWrap) dotsWrap.removeEventListener('click', onDotClick);
    };
  }

  /* ════════════════════════════════════════
     START + RESIZE
  ════════════════════════════════════════ */
  function init() {
    if (!document.getElementById('vbgIngaStage2')) return;
    IS_MOBILE = window.innerWidth <= 768;
    reorderHybridList();
    if (window.gsap) {
      gsap.delayedCall(0.15, runAnimation);
    } else {
      window.addEventListener('load', runAnimation);
    }
    initInteractions();
    /* initCarousel() wird von runAnimation() aufgerufen, nicht hier */
  }

  var resizeTimer;
  var lastWidth = window.innerWidth;
  window.addEventListener('resize', function() {
    /* Mobile: Adressleiste ein-/ausblenden ändert nur die Höhe.
       Animation nur bei echter Breitenänderung neu starten. */
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      IS_MOBILE = window.innerWidth <= 768;
      if (window.gsap) gsap.killTweensOf('*');
      runAnimation();
      reorderHybridList();
    }, 300);
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

/* ════════════════════════════════════════
   LIGHTBOX
   Unabhängig von INGA – für alle .vbg-lightbox-trigger Bilder
════════════════════════════════════════ */
(function () {
  'use strict';

  function buildLightbox() {
    // Schon vorhanden?
    if (document.getElementById('vbg-lightbox')) return;

    var lb = document.createElement('div');
    lb.id = 'vbg-lightbox';
    lb.innerHTML =
      '<button id="vbg-lightbox-close" aria-label="Schließen">✕</button>' +
      '<img id="vbg-lightbox-img" src="" alt="">';
    document.body.appendChild(lb);

    var img   = document.getElementById('vbg-lightbox-img');
    var close = document.getElementById('vbg-lightbox-close');

    function openLb(src, alt) {
      img.src = src;
      img.alt = alt || '';
      lb.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeLb() {
      lb.classList.remove('active');
      document.body.style.overflow = '';
      // Kurz warten dann src leeren (verhindert flash)
      setTimeout(function() { img.src = ''; }, 300);
    }

    close.addEventListener('click', closeLb);
    lb.addEventListener('click', function(e) {
      if (e.target === lb) closeLb();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeLb();
    });

    // Alle aktuellen + zukünftigen Trigger via Delegation
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('.vbg-lightbox-trigger');
      if (!trigger) return;
      e.preventDefault();
      var src = trigger.src || trigger.querySelector('img') && trigger.querySelector('img').src;
      if (!src) return;
      // Höhere Auflösung: width-Parameter erhöhen
      src = src.replace(/width=\d+/, 'width=1600');
      openLb(src, trigger.alt || '');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildLightbox);
  } else {
    buildLightbox();
  }
})();
